module.exports = __webpack_public_path__ + "static/media/service-right.245f73a1.svg";